export default function sliceShopifyIdNumber(storefrontId: string): number {
	return Number(storefrontId.slice(storefrontId.lastIndexOf("/") + 1)); // 40722568872072
}
